function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import { Button, Input, Menu } from 'mkui-fd';
var Search = Input.Search;

var CurrencyPanel = function CurrencyPanel(props) {
  var _onSelect = props.onSelect,
      dataSources = props.dataSources;

  var _useState = useState(dataSources),
      _useState2 = _slicedToArray(_useState, 2),
      store = _useState2[0],
      setStore = _useState2[1];

  var queryHandle = function queryHandle(value) {
    if (!value) {
      setStore(dataSources);
      return;
    }

    setStore(function (data) {
      return _toConsumableArray(data.filter(function (item) {
        var code = item.code,
            name = item.name;
        return code.indexOf(value) > -1 || name.indexOf(value) > -1;
      }));
    });
  };

  return React.createElement("div", {
    className: "currency-panel"
  }, React.createElement(Search, {
    placeholder: "\u8BF7\u8F93\u5165\u5E01\u79CD\u5173\u952E\u5B57",
    onSearch: queryHandle
  }), store.length <= 0 ? React.createElement("span", null, " \u6682\u65E0\u6570\u636E") : React.createElement(Menu, {
    onSelect: function onSelect(_ref) {
      var key = _ref.key;

      _onSelect([key]);
    }
  }, store.map(function (ds) {
    return React.createElement(Menu.Item, {
      key: ds.code
    }, ds.code, React.createElement("span", null, " - ", ds.name));
  })));
};

export default CurrencyPanel;
//# sourceMappingURL=CurrencyPanel.js.map
